/*
 * @Date: 2020-03-12 17:26:55
 * @LastEditTime: 2020-03-15 14:22:39
 * @Description: file content
 */
// import Message from "./Message"

export function delay(millisecond) {
  return new Promise((resolve) => {
    setTimeout(resolve, millisecond)
  })
}
/**
 * 接收檔案 並回傳 dataUrl
 * @param {File} file Html 表單上傳的檔案
 * @returns {Promise<String>}
 */
export function toDataUrl(file){
  return new Promise((resolve, reject)=>{
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })
}
/**
 * 將 message 過濾並顯示至 console
 */
export function messageLogger(event) {
  try {
    if (typeof event.data === 'string') {
      if (event.data.indexOf('webpack') > -1) {
        return
      }
    }
    if (typeof event.data === 'object') {
      if ((event.data.type && event.data.type.includes('webpack') !== -1) ||
        (event.data.source && event.data.source.includes('vue-devtools') !== -1)
      ) {
        // eslint-disable-next-line no-useless-return
        return
      }
    }
    if (event.data && event.data.type) {
      console.log('child-msg:', `type(${event.data.type})`, event)
    } else {
      console.log('child-msg:', event.data, event)
    }
  } catch (e) {
    console.warn(e)
  }
}

/* -------------------------------- 格式化时间字符串 -------------------------------- */
export function formatDate(date, type) {
  if (!date) {
    return ''
  }
  date = new Date(date)
  var year = date.getFullYear() // 年
  var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1 // 月
  var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate() // 日
  var hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours() // 时
  var minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes() // 分
  var seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds() // 秒
  var milliseconds = date.getMilliseconds() < 10 ? '0' + date.getMilliseconds() : date.getMilliseconds() // 毫秒

  switch (type) {
    case 'yyyy-mm-dd hh:MM:ss.fff':
      return year + '-' + month + '-' + day + ' ' + hour + ':' + minutes + ':' + seconds + '.' + milliseconds
    case 'yyyymmddhhMMss':
      return year + '' + month + '' + day + '' + hour + '' + minutes + '' + seconds
    case 'yyyy-mm-dd hh:MM:ss':
      return year + '-' + month + '-' + day + ' ' + hour + ':' + minutes + ':' + seconds
    case 'yyyy-mm-dd hh:MM':
      return year + '-' + month + '-' + day + ' ' + hour + ':' + minutes
    case 'yyyymmdd':
      return year + '' + month + '' + day
    case 'yyyy.mm.dd':
      return year + '.' + month + '.' + day
    default:
      return year + '-' + month + '-' + day
  }
}
